export default __webpack_public_path__ + "static/media/project-managment.61b4f6bc.svg";